const VISITOR_ITEM_KEY = 'visitors';
const OPEN_ITEM_KEY = 'opens';
const ACTION_ITEM_KEY = 'actions';
const LEAD_ITEM_KEY = 'leads';
export const SALE_ITEM_KEY = 'sales';

export type EngagementItemKey =
    | typeof VISITOR_ITEM_KEY
    | typeof OPEN_ITEM_KEY
    | typeof ACTION_ITEM_KEY
    | typeof LEAD_ITEM_KEY
    | typeof SALE_ITEM_KEY;

export type EngagementItem = {
    // Used to map static frontend values to corresponding dynamic funnel detail values
    key: EngagementItemKey;
    title: string;
    valueSubtitle: string;
    tooltip: {
        description: string;
        example: string;
    };
    isHoverable?: boolean;
};

export const VISITORS_TOOLTIP: {description: string; example: string} = {
    description:
        'Every person who visited your site with the Chat widget embedded for the first time during the selected time period.',
    example: 'Example: If someone visits 5 pages, they’re only counted once.',
};

const VISITORS_ITEM: EngagementItem = {
    key: VISITOR_ITEM_KEY,
    title: 'Visitors',
    valueSubtitle: 'Visitors',
    tooltip: VISITORS_TOOLTIP,
};

const OPENS_ITEM: EngagementItem = {
    key: OPEN_ITEM_KEY,
    title: 'Opens',
    valueSubtitle: 'Opens',
    tooltip: {
        description:
            'Every visitor who opened the Chat Widget is counted here. Even if they open it more than once, they’ll only be counted once.',
        example:
            'Example: A visitor has opened the Chat widget by clicking on the nudge or ‘Call’ on the Engagement Bar.',
    },
};

const ACTIONS_ITEM: EngagementItem = {
    key: ACTION_ITEM_KEY,
    title: 'Actions',
    valueSubtitle: 'Actions',
    tooltip: {
        description:
            'Visitors who complete an action from the chat widget (e.g. chat, call, email, or quote) will counted as 1.',
        example: 'Example: A visitor submits a quote form through the Engagement Bar.',
    },
};

const LEADS_ITEM: EngagementItem = {
    key: LEAD_ITEM_KEY,
    title: 'Leads',
    valueSubtitle: 'Leads',
    tooltip: {
        description: 'Visitors who became leads after engaging with the chat widget.',
        example:
            'Example: Filling out a quote form turns a visitor into a lead and adds them to your pipeline.',
    },
    isHoverable: true,
};

const SALES_ITEM: EngagementItem = {
    key: SALE_ITEM_KEY,
    title: 'Sales',
    valueSubtitle: 'Sales',
    tooltip: {
        description: 'Leads captured through your chat widget who successfully became customers.',
        example:
            'Example: Leads who accept a proposal after sending a quote request through the chat widget.',
    },
    isHoverable: true,
};

export const ENGAGEMENT_ITEMS: EngagementItem[] = [
    VISITORS_ITEM,
    OPENS_ITEM,
    ACTIONS_ITEM,
    LEADS_ITEM,
    SALES_ITEM,
];
